import uppyLocaleEs from '@uppy/locales/lib/es_ES.js';

export default {
  'A modern, customizable file manager component built for Vue.':
    'Un gestor de archivos moderno y personalizable creado para Vue.',
  'Project Home': 'Página del proyecto',
  'If you like it, please follow and ⭐ star on GitHub.':
    'Si te gusta, síguenos y añade una ⭐ estrella en GitHub.',
  Language: 'Idioma',
  Create: 'Crear',
  Close: 'Cerrar',
  Cancel: 'Cancelar',
  Save: 'Guardar',
  Edit: 'Editar',
  Crop: 'Recortar',
  'New Folder': 'Nueva Carpeta',
  'New File': 'Nuevo Archivo',
  Rename: 'Renombrar',
  Delete: 'Eliminar',
  Upload: 'Subir',
  Download: 'Descargar',
  Archive: 'Archivar',
  Unarchive: 'Desarchivar',
  Open: 'Abrir',
  'Open containing folder': 'Abrir carpeta contenedora',
  Refresh: 'Actualizar',
  Preview: 'Vista previa',
  'Toggle Full Screen': 'Alternar pantalla completa',
  'Change View': 'Cambiar vista',
  Storage: 'Almacenamiento',
  'Go up a directory': 'Subir un directorio',
  Go: 'Ir',
  'Enter folder path:': 'Ingrese la ruta de la carpeta:',
  'Invalid path format. Path must be in format: storage://path/to/folder':
    'Formato de ruta inválido. La ruta debe estar en formato: storage://path/to/folder',
  'Invalid storage. Storage "%s" is not available.':
    'Almacenamiento inválido. El almacenamiento "%s" no está disponible.',
  'Failed to navigate to folder': 'Error al navegar a la carpeta',
  'Copy Path': 'Copiar ruta',
  'Copy Download URL': 'Copiar URL de descarga',
  'Search anything..': 'Buscar cualquier cosa..',
  Name: 'Nombre',
  Size: 'Tamaño',
  Date: 'Fecha',
  Filepath: 'Ruta del archivo',
  'Folder Name': 'Nombre de carpeta',
  'File Name': 'Nombre de archivo',
  'Move files': 'Mover archivos',
  'Yes, Move!': '¡Sí, mover!',
  'Delete files': 'Eliminar archivos',
  'Yes, Delete!': '¡Sí, eliminar!',
  'Upload Files': 'Subir archivos',
  'No files selected!': '¡No hay archivos seleccionados!',
  'Select Files': 'Seleccionar archivos',
  'Archive the files': 'Archivar los archivos',
  'Unarchive the files': 'Desarchivar los archivos',
  'The archive will be unarchived at': 'El archivo se desarchivará en',
  'Archive name. (.zip file will be created)': 'Nombre del archivo. (Se creará un archivo .zip)',

  'Create a new folder': 'Crear una nueva carpeta',
  'Create a new file': 'Crear un nuevo archivo',
  'Are you sure you want to delete these files?':
    '¿Estás seguro de que quieres eliminar estos archivos?',
  "I'm sure delete it, This action cannot be undone.":
    'Confirmo que quiero eliminar esto. Esta acción no se puede deshacer.',
  'Search results for': 'Resultados de búsqueda para',
  '%s item(s) selected.': '%s elemento(s) seleccionado(s).',
  '%s is renamed.': '%s ha sido renombrado.',
  'This is a readonly storage.': 'Este es un almacenamiento de solo lectura.',
  '%s is created.': '%s ha sido creado.',
  'Files moved.': 'Archivos movidos.',
  'Files deleted.': 'Archivos eliminados.',
  'The file unarchived.': 'El archivo desarchivado.',
  'The file(s) archived.': 'El/los archivo(s) archivado(s).',
  'Updated.': 'Actualizado.',
  'No search result found.': 'No se encontraron resultados de búsqueda.',
  'Are you sure you want to move these files?':
    '¿Estás seguro de que quieres mover estos archivos?',
  'File Size': 'Tamaño del archivo',
  'Last Modified': 'Última modificación',
  'Select Folders': 'Seleccionar carpetas',
  'Clear all': 'Limpiar todo',
  'Clear only successful': 'Limpiar solo exitosos',
  'Drag and drop the files/folders to here.': 'Arrastra y suelta los archivos/carpetas aquí.',
  'You can drag & drop files anywhere while this modal is open.':
    'Puedes arrastrar y soltar archivos en cualquier lugar mientras este modal esté abierto.',
  Canceled: 'Cancelado',
  Done: 'Hecho',
  'Network Error, Unable establish connection to the server or interrupted.':
    'Error de red, No se pudo establecer conexión con el servidor o se interrumpió.',
  'Pending upload': 'Pendiente',
  'Please select file to upload first.': 'Por favor selecciona un archivo para subir primero.',

  Settings: 'Configuración',
  Shortcuts: 'Atajos',
  Reset: 'Restablecer',
  Escape: 'Escape',
  Search: 'Buscar',
  'Toggle Sidebar': 'Alternar barra lateral',
  'Open Settings': 'Abrir configuración',
  'Reset all settings to default': 'Restablecer toda la configuración por defecto',
  'Saved.': 'Guardado.',
  'Reset Settings': 'Restablecer configuración',
  'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
    '¿La descarga no funciona? Puedes intentar hacer clic derecho en el botón "Descargar", seleccionar "Guardar enlace como...".',
  Theme: 'Tema',
  'Target Directory': 'Directorio de destino',
  Select: 'Seleccionar',
  'Show thumbnails': 'Mostrar miniaturas',
  'Persist Path': 'Mantener ruta',
  'Metric Units': 'Unidades métricas',
  'Select All': 'Seleccionar todo',
  'Pinned Folders': 'Carpetas fijadas',
  'No folders pinned': 'No hay carpetas fijadas',
  'No folders': 'No hay carpetas',
  'No items': 'No hay elementos',
  'Pin Folder': 'Fijar carpeta',
  'Unpin Folder': 'Desfijar carpeta',
  'Project home': 'Inicio del proyecto',
  'Follow on GitHub': 'Seguir en GitHub',
  'Customize your experience with the following settings':
    'Personaliza tu experiencia con la siguiente configuración',
  File: 'Archivo',
  View: 'Vista',
  Tools: 'Herramientas',
  Help: 'Ayuda',
  Exit: 'Salir',
  'Deselect All': 'Deseleccionar todo',
  Cut: 'Cortar',
  Copy: 'Copiar',
  Paste: 'Pegar',
  'Grid View': 'Vista de cuadrícula',
  'List View': 'Vista de lista',
  'Tree View': 'Vista de árbol',
  'Show Thumbnails': 'Mostrar miniaturas',
  'Full Screen': 'Pantalla completa',
  items: 'elementos',
  selected: 'seleccionado',
  About: 'Acerca de',
  Git: 'Git',
  Forward: 'Adelante',
  Back: 'Atrás',
  'Go to Folder': 'Ir a carpeta',
  Sorting: 'Ordenamiento',
  Asc: 'Asc',
  Desc: 'Desc',
  None: 'Ninguno',
  Show: 'Mostrar',
  'All items': 'Todos los elementos',
  'Files only': 'Solo archivos',
  'Folders only': 'Solo carpetas',
  'Show hidden files': 'Mostrar archivos ocultos',
  'Copy files': 'Copiar archivos',
  'Are you sure you want to copy these files?':
    '¿Estás seguro de que quieres copiar estos archivos?',
  'Yes, Copy!': '¡Sí, copiar!',
  'Files copied.': 'Archivos copiados.',
  Browse: 'Navegar',
  'Create a copy instead of moving': 'Crear una copia en lugar de mover',
  'Select Target Folder': 'Seleccionar carpeta de destino',
  Storages: 'Almacenamientos',
  Loading: 'Cargando',
  'Search files': 'Buscar archivos',
  'Failed to open containing folder': 'Error al abrir la carpeta contenedora',
  'Include subfolders': 'Incluir subcarpetas',
  'More actions': 'Más acciones',
  'Open Containing Folder': 'Abrir carpeta contenedora',
  'Searching...': 'Buscando...',
  'No results found': 'No se encontraron resultados',
  'Search Options': 'Opciones de búsqueda',
  'All Files': 'Todos los archivos',
  'Small (< 1MB)': 'Pequeño (< 1MB)',
  'Medium (1-10MB)': 'Mediano (1-10MB)',
  'Large (> 10MB)': 'Grande (> 10MB)',
  'Start typing to search files. Use options to filter or include subfolders.':
    'Comienza a escribir para buscar archivos. Usa las opciones para filtrar o incluir subcarpetas.',
  'Failed to rename': 'Error al renombrar',
  'Name cannot contain slashes.': 'El nombre no puede contener barras.',
  'Zoom in': 'Acercar',
  'Zoom out': 'Alejar',
  'Reset zoom': 'Restablecer zoom',
  'Sort by': 'Ordenar por',
  'Name (A-Z)': 'Nombre (A-Z)',
  'Name (Z-A)': 'Nombre (Z-A)',
  'Size (smallest)': 'Tamaño (más pequeño)',
  'Size (largest)': 'Tamaño (más grande)',
  'Date (newest)': 'Fecha (más reciente)',
  'Date (oldest)': 'Fecha (más antigua)',
  'Preview as': 'Vista previa como',
  Text: 'Texto',
  Image: 'Imagen',
  Table: 'Tabla',
  Raw: 'Sin procesar',
  'View as table': 'Ver como tabla',
  'View as raw': 'Ver sin procesar',
  'Failed to parse CSV': 'Error al analizar CSV',
  'No rows to display': 'No hay filas para mostrar',
  'Showing first %s rows out of %s': 'Mostrando las primeras %s filas de %s',
  'Path copied to clipboard': 'Ruta copiada al portapapeles',
  'Toggle Path Copy Mode': 'Alternar modo de copia de ruta',
  'Target folder': 'Carpeta de destino',
  Pinned: 'Anclado',
  uppy: uppyLocaleEs,

  // Auto-added by sync-locales.mjs — English fallback, please translate.
  Rotate: 'Rotate',
  Grayscale: 'Grayscale',
  Adjust: 'Adjust',
  Apply: 'Apply',
  Brightness: 'Brightness',
  Contrast: 'Contrast',
  Saturation: 'Saturation',
  Original: 'Original',
  'Rotate left 90°': 'Rotate left 90°',
  'Rotate right 90°': 'Rotate right 90°',
  'Flip horizontal': 'Flip horizontal',
  'Flip vertical': 'Flip vertical',
  'File info': 'File info',
  Type: 'Type',
  Dimensions: 'Dimensions',
  Duration: 'Duration',
  Path: 'Path',
  'Download help': 'Download help',
  'Discard unsaved changes?': 'You have unsaved changes. Discard?',
  Editing: 'Editing',
  Unsaved: 'Unsaved',
  'File %s of %s': 'File %s of %s',
  'Toggle word wrap': 'Toggle word wrap',
  'Word wrap on — click to disable': 'Word wrap on — click to disable',
  'Word wrap off — click to enable': 'Word wrap off — click to enable',
  Recent: 'Recent',
  'Remove from recent': 'Remove from recent',
  'Edit this path': 'Edit this path',
  'No recent folders yet.': 'No recent folders yet.',
  'No matching folders.': 'No matching folders.',
  'Folder not found': 'Folder not found',
  'Loading…': 'Loading…',

  'Show as table': 'Show as table',
};
